




import {Vue, Component} from 'vue-property-decorator'

import ConfigChannel  from '@/components/ConfigChannel.vue'

@Component({
  components: {
      ConfigChannel
  }
})
export default class ConfigChannelView extends Vue {
}
